<script lang="ts">
    import { computed, ComputedRef, DefineComponent, onMounted, Ref, ref } from 'vue';
    import vm from '@journeys/Journeys.viewmodel';
    import { NodeType } from '@journeys/Enums';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'PropertyWindow',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    // components
    import NodeLists from './Menues/NodeLists.vue';
    import PublishJourney from './Menues/PublishJourney.vue';
    import JourneySettings from './Menues/JourneySettings.vue';
    import NodeSettings from './Menues/NodeSettings.vue';
    import SaveAsTemplate from './Menues/SaveAsTemplate.vue';

    // dev components
    import DeveloperMenu from '@cwd/dev/components/menues/MenuDeveloper.vue';

    import Scrollbar3d from '@shared/components/Scrollbar3d.vue';

    const { editor, canvas, nav, viewport, settings, activeJourney } = vm;

    let menuCache: any = undefined;
    const activeMenu = computed(() => {
        // if (editor.state.showNodeMenu && editor.state.activeMenu === menuCache)
        //    editor.state.showNodeMenu = false
        let node = editor.tools.sel_keyObj ? activeJourney.nodes[editor.tools.sel_keyObj] : null;
        if (node?.data.type !== NodeType.Text && editor.state.showNodeMenu && editor.tools.sel_count > 0) return NodeSettings;

        switch (editor.state.activeMenu) {
            case 'nodelists':
                return (menuCache = NodeLists);
            case 'publish':
                return (menuCache = PublishJourney);
            case 'settings':
                return (menuCache = JourneySettings);
            case 'savetemplate':
                return (menuCache = SaveAsTemplate);
            case 'developer':
                return (menuCache = DeveloperMenu);
            default:
                return NodeLists;
        }
    });
</script>

<template>
    <div class="property-window" :class="editor.state.showPropertyWindow && 'active'">
        <!-- <transition name="component-roll" mode="out-in"> -->
        <keep-alive include="Menu_PublishJourney">
            <component :is="activeMenu"></component>
        </keep-alive>
        <!-- </transition> -->

        <Scrollbar3d
            placement="left"
            :style="`left: -18px`"
            :scrollSize="canvas.h.value"
            :scrollMin="-canvas.sh - canvas.ext.t"
            :containerSize="viewport.dims.h"
            :nav="nav"
            axis="y" />

        <input type="text" class="chrome-autofill-workaraound" />
    </div>

    <Scrollbar3d
        placement="bottom"
        :style="`width: ${viewport.dims.w}px`"
        :scrollSize="canvas.w.value"
        :scrollMin="-canvas.sw - canvas.ext.l + nav.zscale_up(editor.state.showPropertyWindow ? (settings.ui.propertyWindowSize * settings.ui.rem) / 2 : 0)"
        :containerSize="viewport.dims.w"
        :nav="nav"
        axis="x" />
</template>

<style lang="less">
    .chrome-autofill-workaraound {
        opacity: 0;
        max-height: 0;
        max-width: 0;
        position: absolute;
        pointer-events: none;
    }

    .component-roll-enter-active,
    .component-roll-leave-active {
        transition-property: opacity, transform;
        transition-duration: 0.08s;
        transition-timing-function: ease-out;
    }

    .component-roll-leave-active {
        transition-duration: 0.12s;
    }

    .component-roll-enter-from {
        transform: translate3d(0, -0.2rem, 0);
        opacity: 0;
    }

    .component-roll-leave-to {
        transform: translate3d(0, 0.2rem, 0);
        opacity: 0;
    }

    .property-window {
        --left-jut: 0.625rem;
        --pane-width: calc(var(--editor-edit-pane-width) - var(--editor-edit-pane-nav-width));

        display: flex;
        position: absolute;
        flex-direction: column;
        flex-shrink: 0;
        top: 0;
        right: var(--editor-edit-pane-nav-width);
        height: 100%;
        width: calc(var(--pane-width) + var(--left-jut));
        padding: 0.6rem 0.25rem 0.75rem 1.25rem;
        box-shadow: var(--editor-pane-right-shadow);
        background-color: var(--bg-color);
        transition-property: transform;
        transition-duration: var(--td-four);
        transition-timing-function: var(--ttf-eager);
        /* will-change: margin-right, background-color; */
        /* will-change: transform; */
    }

    .property-window.active:has(.show-node-menu) {
        --pane-width: var(--editor-edit-pane-width);
        z-index: 5;
        right: 0;
        // transform: none !important;
    }

    .property-window .scrollable-wrapper {
        padding-left: 0.1rem;
        padding-right: 0.65rem;
        overflow-x: hidden;
    }

    .property-window:not(.active) {
        /* transform: translate3d(calc(100% - .5rem), 0, 0); */
        transform: translate3d(calc(100% - var(--left-jut)), 0, 0);

        transition-property: transform, background-color;
        transition-delay: 0s, var(--td-four);
    }

    .static-container {
        flex: 0;
        margin-right: 0.8rem;
    }
</style>
